import React from "react";
import Box from "../../component/Box/Box";
import PropTypes from "prop-types";
import Notify from "../../services/Notify";
import Loading from "../../component/Loading/Loading";
import ReadpointService from "../../services/ReadpointService";
import ReadpointTypeSelector from "./ReadpointTypeSelector";
import FormButtons from "../../component/Form/FormButtons";
import {InputWithLabel} from "../../component/Form/InputWithLabel";
import ReadpointMomentReadSelector from "./ReadpointMomentReadSelector";

class ReadpointForm extends React.Component {

  service = new ReadpointService();

  constructor(props) {
    super(props);
    this.state = {};
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const {match} = this.props;
    const id = match.params.id;
    if (id) {
      const state = this.state;
      state.loading = true;
      this.setState(state);
      this.service.findById(id).then(
        data => this.setState(
          {
            loading: false,
            entity: data
          }),
        error => {
          const state = {loading: false};
          if (error.response.status === 404) {
            state.message = 'Entidade não encontrada!';
          } else {
            state.message = 'Erro inesperado!';
            Notify.error('Falha o buscar entidade!', error)
          }
          this.setState(state);
        }
      )
    }
  }

  submitForm() {
    const existingEntity = this.state.entity && this.state.entity.id;
    const entityVersion = this.state.entity && this.state.entity.version;
    const entity = {
      id: existingEntity,
      friendlyName: this.friendlyName && this.friendlyName.trim() || this.state.entity && this.state.entity.friendlyName,
      description: this.description || this.state.entity && this.state.entity.description,
      rpGroup: this.rpGroup || this.state.entity && this.state.entity.rpGroup,
      momentRead: this.momentRead || this.state.entity && this.state.entity.momentRead || 'STOP_READ',
      type: this.type,
      version: entityVersion
    };
    this.setState({loading: true, message: 'Salvando...'});
    this.service.save(entity).then(
      () => {
        this.props.history.goBack();
        Notify.success('Entidade salva');
      },
      (error) => {
        Notify.error('Falha ao salvar entidade:', error);
        this.setState({loading: false, entity, message: null});
      });
  }

  onChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.state.isIntegrated = value;
    this.setState(this.state);
  }

  render() {
    const {loading, entity, message} = this.state;
    if (loading) {
      return <Loading message={message}/>
    }
    if (message) {
      return <h2>{message}</h2>
    }

    return (
      <Box info>
        <form ref={form => (this.form = form)} onSubmit={event => {
          event.preventDefault();
          this.submitForm()
        }}>

          <InputWithLabel
            label="Nome"
            inputType="text"
            onChange={e => this.friendlyName = e.target.value}
            defaultValue={entity && entity.friendlyName}
          />

          <InputWithLabel
            label="Descrição"
            inputType="text"
            onChange={e => this.description = e.target.value}
            defaultValue={entity && entity.description}
          />

          <InputWithLabel
            label="Agrupador"
            inputType="text"
            onChange={e => this.rpGroup = e.target.value}
            defaultValue={entity && entity.rpGroup}
          />

          <ReadpointMomentReadSelector defaultValue={entity && entity.momentRead} setValue={x => this.momentRead = x}/>

          <ReadpointTypeSelector required={true}
                                 defaultValue={entity && entity.type}
                                 setValue={value => this.type = value}/>

          <FormButtons history={this.props.history}/>
        </form>
      </Box>)
      ;
  }
}

ReadpointForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default ReadpointForm;



// WEBPACK FOOTER //
// ./src/readpoint/component/ReadpointForm.js